import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../ui/button';
import Spinner from '../ui/spinner';
import type { useModal } from './new/use-modal';
import { Modal } from './new/modal';

export interface ConfirmDeleteModalProps {
  title: string;
  description?: React.ReactNode;
  onClose?: () => void;
  onSubmit: () => Promise<void> | void;
  modal: ReturnType<typeof useModal>;
}

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  title,
  description,
  onClose,
  onSubmit,
  modal,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const closeModalHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    modal.dismiss();
    return onClose?.();
  };
  const submitHandler = async (e: React.MouseEvent) => {
    e.stopPropagation();

    try {
      setLoading(true);
      await onSubmit();
      modal.dismiss();
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal {...modal} title={title} className="max-w-96">
      <Modal.Body>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-primary-lighter/40">
            <Spinner className="size-12 [&_*]:stroke-primary-dark" />
          </div>
        )}
        {typeof description === 'string' ? (
          <p className="mt-6 text-center text-base text-text-secondary">{description}</p>
        ) : (
          description
        )}
      </Modal.Body>
      <Modal.Actions>
        <Button className="w-full" onClick={closeModalHandler} variant="outline">
          {t('cancel')}
        </Button>
        <Button className="w-full" variant="destructive" onClick={submitHandler}>
          {t('delete')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
